// Required for dev hot reload

if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR")
  });
}

import searchDrawer from './components/search-drawer';
document.addEventListener('DOMContentLoaded', searchDrawer, false);

import initMegaMenu from './modules/megaMenu';
document.addEventListener('DOMContentLoaded', initMegaMenu, false);

import initstandardSwiper from './modules/standardSwiper';
document.addEventListener('DOMContentLoaded', initstandardSwiper, false);

import initInlineModal from './modules/inlineModal';
document.addEventListener('DOMContentLoaded', initInlineModal, false);

import initscrollDrag from './modules/scrollDrag';
document.addEventListener('DOMContentLoaded', initscrollDrag, false);

import initNewsletterSignup from './modules/newsletter';
document.addEventListener('DOMContentLoaded', initNewsletterSignup, false);

import initoffCanvasSwiper from './modules/offCanvasSwiper';
document.addEventListener('DOMContentLoaded', initoffCanvasSwiper, false);

import initRequestQuoteModal from './modules/requestQuote';
document.addEventListener('DOMContentLoaded', initRequestQuoteModal, false);

import initHomeHeroCardSwiper from './modules/homeHeroCardSwiper';
document.addEventListener('DOMContentLoaded', initHomeHeroCardSwiper, false);

import initExploreProductsSwiper from './modules/exploreProductsSwiper';
document.addEventListener('DOMContentLoaded', initExploreProductsSwiper, false);

import initWorkSlider from './modules/workSlider';
document.addEventListener('DOMContentLoaded', initWorkSlider, false);

import initTicker from './modules/ticker';
document.addEventListener('DOMContentLoaded', initTicker, false);

import initTickerX from './modules/tickerX';
document.addEventListener('DOMContentLoaded', initTickerX, false);

import '../css/app.css';
import 'virtual:svg-icons-register';

// Import and initialize alpine js
import './alpine/index';